import { register, sendCode, login, logout, codeLogin, updatePswLogin, getUserInfo, getUserDetails, bindEduStaff, bindStaffDefaultStudent, getXCode } from '@/api/login/index';
import { sendCodeByChangePhone, saveNewPhone, updateUserPsw, unbindStaff, unbindStaffCode, bindStaff } from '@/api/setting/index';
import { getToken, setToken, setExpiresIn, removeToken } from '@/utils/auth';

const user = {
  state: {
    token: getToken(),
    userInfo: [],
    staffInfo: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time;
    },
    SET_USER_INFO: (state, data) => {
      state.userInfo = data;
    },
    SET_STAFF_INFO: (state, data) => {
      state.staffInfo = data;
    }
  },

  actions: {
    // 获取验证码
    SendSmscode({ commit }, data) {
      return new Promise((resolve, reject) => {
        sendCode(data).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 注册并登录
    RegisterAndLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        register(userInfo).then(res => {
          const data = res.data;
          setToken(data.access_token);
          commit('SET_TOKEN', data.access_token);
          setExpiresIn(data.expires_in);
          commit('SET_EXPIRES_IN', data.expires_in);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 账号密码登录
    GetLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          const data = res.data;
          setToken(data.access_token);
          commit('SET_TOKEN', data.access_token);
          setExpiresIn(data.expires_in);
          commit('SET_EXPIRES_IN', data.expires_in);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 手机号验证码登录
    GetCodeLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        codeLogin(userInfo).then(res => {
          const data = res.data;
          setToken(data.access_token);
          commit('SET_TOKEN', data.access_token);
          setExpiresIn(data.expires_in);
          commit('SET_EXPIRES_IN', data.expires_in);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 设置新密码
    resetPswLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        updatePswLogin(userInfo).then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout({ Authorization: 'Bearer ' + state.token }).then(() => {
          commit('SET_TOKEN', '');
          removeToken();
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取用户信息
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then((res) => {
          commit('SET_USER_INFO', res.data);
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 修改手机号码的发送验证码
    SendCodeByChangePhone({ commit }, data) {
      return new Promise((resolve, reject) => {
        sendCodeByChangePhone(data).then((res) => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 修改手机号码并保存
    SaveChangePhone({ commit }, data) {
      return new Promise((resolve, reject) => {
        saveNewPhone(data).then((res) => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 用户修改密码
    UpdateUserPsw({ commit }, data) {
      return new Promise((resolve, reject) => {
        updateUserPsw(data).then((res) => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 带用户认证信息的用户详情
    GetUserDetailInfo() {
      return new Promise((resolve, reject) => {
        getUserDetails().then((res) => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 登录绑定认证教职工
    BindEduStaff({ commit }, data) {
      return new Promise((resolve, reject) => {
        bindEduStaff(data).then((res) => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 登录绑定认证教职工的默认海亮学生
    BindDetaultStudent({ commit }, data) {
      return new Promise((resolve, reject) => {
        bindStaffDefaultStudent(data).then((res) => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 教职工认证解绑/绑定获取验证码
    UnbindStaffCode({ commit }, data) {
      return new Promise((resolve, reject) => {
        unbindStaffCode(data).then((res) => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 教职工认证解绑
    UnbindStaff({ commit }, data) {
      return new Promise((resolve, reject) => {
        unbindStaff(data).then((res) => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 教职工认证绑定
    BindStaff({ commit }, data) {
      return new Promise((resolve, reject) => {
        bindStaff(data).then((res) => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取多网校code
    GetXCode({ commit }, data) {
      return new Promise((resolve, reject) => {
        getXCode(data).then((res) => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/user.js